<template>
  <CDropdown
    addMenuClasses="mcustom-menu overflow-auto"
    :show="showMe">
    <template v-slot:toggler>
      <CInput 
        addLabelClasses="text-muted font-weight-bold"
        :label="label"
        :class="disabled ? 'disabled' : ''"
        :disabled="disabled"
        :value.sync="search"
        :placeholder="label"
        :isValid="required ? options.some(option => option.label == search) : null "
        @input="showOnTyping"
        @blur="onBlur">
        <template v-if="prepend_content" #prepend-content>
          <template v-if="typeof prepend_content === 'string'">
            {{ prepend_content }}
          </template>
          <template v-if="typeof prepend_content === 'object'">
            <BCIcon :type="prepend_content.type" :name="prepend_content.name"/>
          </template>
        </template>
      </CInput>
    </template>
    <template v-if="filteredOptions.length == 0">
      <CDropdownItem>Sin resultados</CDropdownItem>
    </template>
    <template v-if="filteredOptions.length > 0">
      <CDropdownItem 
        v-for="(option, index) in filteredOptions"
          :key="index"
          @click="selected(option)">
          {{ option.label }}
      </CDropdownItem>
    </template>
  </CDropdown>
</template>
<script>
  import BCIcon from "./BCIcon.vue";
export default {
  components: { BCIcon },
    name: 'CAutocomplete',
    data() {
        return {
          search: "",
          showMe: false
        }
    },
    props: {
        options: {
          type: Array,
          default: () => []
        },
        label: {
          type: String,
          default: ''
        },
        // value: String,
        required: {
          type: Boolean,
          default: false
        },
        disabled: {
          type: Boolean,
          default: false
        },
        prepend_content: {
          type: [ Boolean, Object, String ],
          default: false
        }
    },
    mounted() {
      this.search = this.findCity()
    },
    watch: {
      value() {
        this.search = this.findCity()
      }
    },
    methods: {
        selected(option) {
          this.search = option.label
          this.$emit('update:input', option.value)
        },
        findCity(){
            const city = this.options.find(option => option.value == this.value)
            if (city) {
              return this.options.find(option => option.value == this.value).label
            } else {
              return ''
            }
        },
        showOnTyping(value) {
          this.showMe = value.length > 2;
          this.$emit('update-search', value);
        },
        onBlur() {
          this.search ? null : this.$emit('update:input', '');
        }
    },
    computed: {
      filteredOptions(){
        return this.options.filter(option => option.label.toLowerCase().includes(this.search.toLowerCase()));
      }
    }
}
</script>
<style>
  .mcustom-menu{
    max-height: 25vw;
  }
</style>